export default {
    props: {
        backLink: {
            type: String,
            default: "/",
        },
        canDelete: {
            type: Boolean,
            default: false,
        },
        errors: {
            type: Object,
            default: () => {
                return {};
            },
        },
        successMessage: {
            type: String,
            default: "",
        },
        initialValues: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            errorWatchers: [],
            formValuesSet: false,
            deletePending: false,
        };
    },
    watch: {
        errors(newErrors) {
            this.errorWatchers.forEach((unset) => {
                unset();
            });
            this.errorWatchers = [];
            Object.keys(newErrors).forEach((field) => {
                this.errorWatchers.push(
                    this.$watch(`form.${field}.value`, () => {
                        this.$emit("clear-error", field);
                    })
                );
            });
            if (Object.keys(newErrors).length) {
                this.$nextTick(this.scrollToFirstError);
            }
        },
    },
    emits: ["submit-form", "report-error", "clear-error", "delete"],
    created() {
        if (this.initialValues) {
            this.setFormValues(this.initialValues);
        }
    },
    mounted() {
        this.$el.addEventListener?.("keydown", this.submitOnModifiedEnter);
    },
    beforeUnmount() {
        this.$el.removeEventListener?.("keydown", this.submitOnModifiedEnter);
    },
    methods: {
        scrollToFirstError() {
            const error = this.$el.querySelector?.(".error");
            if (!error) {
                return;
            }
            (error.closest(".form-field") ?? error).scrollIntoView({
                behavior: "smooth",
                block: "center",
            });
        },
        submitOnModifiedEnter(event) {
            const isModifiedEnter =
                event.key === "Enter" && (event.ctrlKey || event.metaKey);
            if (!isModifiedEnter || event.target.tagName !== "TEXTAREA") {
                return;
            }
            event.preventDefault();
            this.$el.querySelector('button[type="submit"]')?.click();
        },
        setFormValues(obj) {
            Object.keys(this.form).forEach((key) => {
                if (this.form[key].convert) {
                    this.form[key].value = this.form[key].convert(obj[key]);
                } else {
                    this.form[key].value = obj[key];
                }
            });

            this.formValuesSet = true;
        },
        markUpdated(field) {
            this.form[field].hasChanged = true;
        },
        emitSubmit(event) {
            event.preventDefault();

            if (this.deletePending) {
                return;
            }

            let data = {};
            let failed = false;

            Object.keys(this.form).forEach((key) => {
                const control = this.form[key];
                const value = control.value;

                if (!control.hasChanged && value === null) {
                    return;
                }

                if (control.skip && control.skip()) {
                    return;
                }

                if (!control.validate || control.validate(value)) {
                    data[key] = value;
                } else {
                    failed = true;
                }
            });

            if (!failed) {
                this.$emit("submit-form", data);
            }
        },
        emitDelete(event) {
            event.preventDefault();
            this.$emit("delete");
        },
        emitError(key, error) {
            this.$emit("report-error", { key, error });
        },
        clear() {
            const defaults = {
                string: null,
                number: null,
            };
            Object.keys(this.form).forEach((key) => {
                const type = typeof this.form[key].value;
                this.form[key].value = defaults[type] ?? null;
            });
        },
    },
};
